<template>
  <div class="c-select">
    <select
      class="c-input-text c-select__element c-select__element--fixedsize"
      name="radius"
      id="radius"
      v-model="radius"
      @change="updateLastInteracted()"
    >
      <option
        v-for="option in $settings('radiusOptions')"
        :key="option"
        :value="option"
        :selected="isSelected(option)"
      >
        {{ option }}km
      </option>
    </select>
    <div class="c-select__wrap-icon">
      <icon icon="arrow-down" />
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Utilities/Icon.vue'
import { mapState } from 'vuex'

export default {
  name: 'RadiusFilter',
  components: {
    icon: Icon,
  },
  computed: {
    ...mapState({
      selectedRadius: (state) => state.filter.radius,
    }),
    radius: {
      get() {
        return this.selectedRadius
      },
      set(value) {
        this.$store.commit('UPDATE_RADIUS', value)
        this.$store.dispatch('getUnits')
      },
    },
  },
  methods: {
    isSelected(option) {
      return option === this.radius
    },
    updateLastInteracted() {
      localStorage.setItem('last_interacted', 'Regular')
    },
  },
}
</script>
